module.exports = __webpack_public_path__ + "img/10.c28f61c3.jpg";